import { Controller } from "@hotwired/stimulus"
import { Upload } from "../components/upload"

export default class extends Controller {
  static targets = [ "input", "list", "clear", "subdomain", "email", "signupForm", "fieldset", "item", "dropzone", "filesError" ]
  static values = { url: String, key: String }

  initialize() {
    this.files = {}
  }

  reset() {
    this.files = {}
    this.refreshHTML()
    document.querySelector("#card").src = "/"
  }

  dragover(event) {
    event.preventDefault()
  }

  drop(event) {
    event.preventDefault()
    if (event.dataTransfer.items) {
      [...event.dataTransfer.items].forEach((item, index) => {
        if (item.kind === 'file') {
          const file = item.getAsFile()
          this.handleFile(file)
        }
      })
    } else {
      [...event.dataTransfer.files].forEach((file, index) => this.pendingFiles[file.name] = file)
    }
  }

  change() {
    for (const file of this.inputTarget.files) {
      this.handleFile(file)
    }
  }

  handleFile(file) {
    const upload = new Upload(this.uploadOptions())
    const data = {
      file: file,
      instance: upload,
    }
    this.listTarget.append(this.fileRow(data))
    this.files[upload.id] = data
    this.uploadFile(data)
  }

  uploadFile(data) {
    return new Promise((resolve, reject) => {
      data.instance.start(data.file)
        .then(result => {
          this.enableLink(result)
          resolve(result)
        })
        .catch(error => reject(error))
    })
  }

  uploadOptions() {
    return {
      presignUrl: "/upload/presign",
      documentsUrl: this.urlValue,
      documentsMethod: "post",
      storage: this.keyValue,
      controller: this,
      callback: this.updateProgress,
    }
  }

  updateProgress(event, controller) {
    if (event.saved) {
      console.log("PROGRESS: Saved")
    } else if (event.uploaded) {
      console.log("PROGRESS: Uploaded")
      controller.updateProgressBar(event)
    } else if (event.progress && event.progress < 100) {
      controller.updateProgressBar(event)
      console.log("PROGRESS:", event.progress)
    } else {
      console.log("PROGRESS:", "Starting...")
    }
  }

  updateProgressBar(event) {
    const item = document.querySelector(`[data-id='${event.id}']`)
    item.querySelector(".progress-bar").style.width = `${event.progress}%`
  }

  enableLink(result) {
    const item = document.querySelector(`[data-id='${result.id}']`)
    const link = item.querySelector(".item-link")
    link.classList.remove("pointer-events-none")
    link.classList.remove("opacity-50")
    link.querySelector("a").href = result.json.url
    item.querySelector(".item-spinner").classList.add("hidden")
    item.querySelector(".item-link-icon").classList.remove("hidden")
  }

  fileRow(file) {
    const template = document.querySelector('#upload-item')
    const clone = template.content.cloneNode(true);
    clone.querySelector(".item-name").innerHTML = file.file.name
    clone.querySelector(".item-size").innerHTML = this.readablizeBytes(file.file.size)
    clone.querySelector("[data-upload-target='item']").dataset.id = file.instance.id
    return clone
  }

  itemTargetConnected() {
    if (this.itemTargets.length > 0) {
      this.listTarget.classList.remove("hidden")
    }
  }

  itemTargetDisconnected() {
    if (this.itemTargets.length < 1) {
      if (this.hasListTarget) this.listTarget.classList.add("hidden")
    }
  }

  remove(event) {
    event.preventDefault()
    const item = event.target.closest("[data-upload-target='item']")
    delete this.pendingFiles[item.dataset.id]
    item.remove()
  }

  readablizeBytes(bytes) {
    var s = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];
    var e = Math.floor(Math.log(bytes) / Math.log(1024));
    return (bytes / Math.pow(1024, e)).toFixed(2) + " " + s[e];
  }
}
